import React from 'react';
import {
  TelInput as KitTelInput,
  TelInputProps
} from '@ianesthesie-kit/tel-input';
import { useTranslator } from '@ianesthesie-kit/core';
import { AppConfigService } from '@/config';

export const TelInput = (props: TelInputProps) => {
  const translate = useTranslator();

  const defaultCountryCode = AppConfigService.getInstance().currentCountry;

  return (
    <KitTelInput
      forceCallingCode
      defaultCountry={defaultCountryCode}
      margin="normal"
      label={translate('app.user.phoneNumber')}
      {...props}
    />
  );
};
